import styled from 'styled-components';

export const StyledSubscriptionEndingModalList = styled.ul`
   padding-left: 20px;
`;
StyledSubscriptionEndingModalList.displayName = 'StyledSubscriptionEndingModalList';
